import React from 'react';
import cookie from 'react-cookies';
import { NavLink } from 'react-router-dom';
import { TooltipContent, Content } from './styles';


const Tooltip: React.FC = () => {
  
  return (
    <TooltipContent>
      <Content>
        <label hidden={!cookie.load('external_stone_codes')}>
          <a href={`${process.env.REACT_APP_API_ENDPOINT}/configuracoes`}>Meu cadastro</a>
        </label>
        <label hidden={!cookie.load('external_stone_codes')}>
          <a href={`${process.env.REACT_APP_API_ENDPOINT}/meu-negocio`}>Meu negócio</a>
        </label>
        <a href="http://stone.com.br/ajuda" target="_blank">Central de Ajuda</a>
        <a href={`${process.env.REACT_APP_API_ENDPOINT}/login`} >Sair</a>
      </Content>
    </TooltipContent>
  )
};
export default Tooltip;
